<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-disabled`]" width="1em" height="1em" v-bind="$attrs"><path d="M8.00049 1.00195C11.8656 1.002 14.9985 4.13582 14.9985 8.00098C14.9985 11.8661 11.8656 14.999 8.00049 14.999C4.13529 14.999 1.00151 11.8662 1.00146 8.00098C1.00151 4.13579 4.13529 1.00195 8.00049 1.00195ZM8.00049 2.33594C4.87167 2.33594 2.33549 4.87217 2.33545 8.00098C2.3355 11.1298 4.87167 13.666 8.00049 13.666C11.1293 13.666 13.6655 11.1298 13.6655 8.00098C13.6655 4.8722 11.1293 2.33599 8.00049 2.33594ZM5.2124 5.21289C5.47204 4.9533 5.89411 4.95339 6.15381 5.21289L10.7876 9.84766C11.0473 10.1073 11.0472 10.5284 10.7876 10.7881C10.5279 11.0478 10.1069 11.0478 9.84717 10.7881L5.2124 6.1543C4.95289 5.89458 4.95277 5.47253 5.2124 5.21289Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDisabled',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
